import React from 'react';
import Asset from '../../../requests/apa/Asset';
import { cls } from '../../../packages/components';
import PersistentMiniEpgChannel from '../PersistentMiniEpgChannel';
import PersistentMiniEpgEvent from '../PersistentMiniEpgEvent';
import PersistentMiniEpgArrow from '../PersistentMiniEpgArrow';
import Utils, { isSkipNoSuscriptionChannelEneable } from '../../../utils/Utils';
import Device from '../../../devices/device';
import ChannelsSingleton from '../../../components/Epg/ChannelsSingleton.js';
import MiniDomManager from '../MiniDomManager';
import {
    NOW_EVENT_TAG,
    FOR_LATE_EVENT_TAG,
    PREVIOUS_EVENT_TAG,
    PAST_EVENTS,
    CURRENT_EVENTS,
    NEXT_EVENTS,
    initGetDataFromApa
  } from '../Helpers/Constans';
import { EPGUtil } from '../../../AAF/Nepg/EPGUtil';
import { HideMiniObserver, ShowMiniObserver, UpdateMiniObserver, UpdateMiniAfterRecordObserver } from '../MiniObserver';
import * as EpgEventsUtils from '../Helpers/EpgEventsUtil';
import TvChannelUtil from '../../../utils/TvChannelUtil';
import LayersControl from '../../../utils/LayersControl';
import { isPastEvent, isCurrentEvent } from '../../EventOptions/EventOptionsUtils';
import ModalEpgUtils from '../../Epg/ModalEpgUtils';
import FallbackUtil from '../../Video/FallbackUtil';
import { AAFPLAYER_PLAY, AAF_CONTENT_IS_CATCHUP, AAF_CONTENT_IS_STARTOVER, AAF_CONTENT_IS_TV, AAF_CONTENT_IS_VOD } from '../../../AAFPlayer/constants';
import * as EpgEventUtils from 'src/components/Epg/EpgEventUtils';
import { connect } from 'react-redux';
import { playFullMedia, playCatchupEvent } from '../../../actions/playmedia';
import { showPassEventNotAvailableNotification, showFutureEventNotAvailableNotification } from '../../../actions/notification';
import { MODAL_PIN, MODAL_INACTIVITY } from '../../../actions/modal';
import EpgPersistence from '../../../AAF/Nepg/EpgPersistence';
import PlayerStreamingUtils from '../../../utils/PlayerStreamingUtils';
import FlagEventMini from '../FlagEventMini';

class MiniEpgOtt extends React.PureComponent{
    constructor(props){
        super(props);
        this.mainContainer = 'main-container';
        this.miniContainer = 'mini-container';
        this.miniDomManager = new MiniDomManager();
        this.keys = Device.getDevice().getKeys();
        this.channels = [];
        this.displayedChannelIndex = 0;
        this.playingChannelIndex = 0;
        this.displayedEventIndex = 0;
        this.displayedChannelEvents = [];
        this.currentEventIndex = 0;
        this.eventFocused = null;
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.updateMiniWithGroupIdFromStorage = this.updateMiniWithGroupIdFromStorage.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleKeyPress= this.handleKeyPress.bind(this);
        this.forcedEvent = null;
        this.wasReseted = false;
        this.handleFocusControl = null;
        this._isPromiseLoading = false;
        this.maxTimeshiftAllowed = null;
        this.notShow = false;
        this.playerStreamingUtils = new PlayerStreamingUtils();
    }

    setChannels(channels){
        if(Array.isArray(channels) && channels.length>0){
            this.channels = channels
        }
    }

    setDisplayedEventIndex(index){
        if(typeof index === 'number')
            this.displayedEventIndex = index;
    }

    setDisplayedChannelEvents(events){
        if(Array.isArray(events) && events.length>0){
            this.displayedChannelEvents = events
        }
    }

    setDisplayedChannelIndex(index){
        if(typeof index === 'number')
            this.displayedChannelIndex = index;
    }

    setPlayingChannelIndex(index){
        if(typeof index === 'number')
            this.playingChannelIndex = index;
    }

    getDisplayedChannel(){
        if(this.channels.length>0){
            return this.channels[this.displayedChannelIndex];
        }
        return null
    }

    getDisplayedEvent(){
        if(this.displayedChannelEvents.length>0){
            return this.displayedChannelEvents[this.displayedEventIndex];
        }
        return null
    }

    getCurrentEvent(){
        if(this.displayedChannelEvents.length>0){
            return this.displayedChannelEvents[this.currentEventIndex];
        }
        return null
    }

    getPlayingChannelGroupId(){
        if(this.channels>0){
            return this.channels[this.playingChannelIndex] && this.channels[this.playingChannelIndex].group_id;
        }
        return null
    }

    show(){
        this.fillChannels();
        this.miniDomManager.showMini();
        if (
            !(document.activeElement === document.getElementById('mini-secondary-event')) &&
            !(document.activeElement === document.getElementById('mini-principal-event'))
        ) {
            //this._focusOnEvent('principal', true);
        }
    }

    hide(){
        this.miniDomManager.hideMini();
    };

    resetChannelIsPlaying(cb = () =>{}){
        if(this.forcedEvent){
            this.resetMiniWithForcedEvent(this.forcedEvent);
        }
        else{
            this.setDisplayedChannelIndex(this.playingChannelIndex);
            this.whereAmI = CURRENT_EVENTS;
            this.updateMiniEpg(null,false,cb);
            this.wasReseted = true;
            this.focusOnEvent('principal', true);
        }
    }

    updateMiniWithGroupIdFromStorage(forcedEvent = null){
        const isForcedEvent = forcedEvent && forcedEvent.group_id;
        const groupIdFromStorage = isForcedEvent ? forcedEvent.group_id : TvChannelUtil.getLastChannel();
        this.whereAmI = CURRENT_EVENTS;
        if (groupIdFromStorage) {
            const indexFound =  this.channels.findIndex(channel => {
                return channel.group_id === groupIdFromStorage;
            });
            if(indexFound!==-1){
                this.setPlayingChannelIndex(indexFound);
            }
            else{
                this.setPlayingChannelIndex(0);
            }
            if(isForcedEvent){
                this.resetMiniWithForcedEvent(forcedEvent);
            }
            else{
                this.forcedEvent= null;
                this.resetChannelIsPlaying();
            }
        }
    }

    resetMiniWithForcedEvent = (forcedEvent) => {
        this.setDisplayedChannelIndex(this.playingChannelIndex);
        if(isPastEvent(forcedEvent)){
            this.whereAmI = PAST_EVENTS;
        }
        else if(isCurrentEvent(forcedEvent)){
            this.whereAmI = CURRENT_EVENTS;
        }
        else{
            this.whereAmI = NEXT_EVENTS;
        }
        this.updateMiniEpg(forcedEvent);
        this.wasReseted = true;
    }

    addEventListener(){
        ShowMiniObserver.unsubscribe(this.show);
        ShowMiniObserver.subscribe(this.show);
        HideMiniObserver.unsubscribe(this.hide);
        HideMiniObserver.subscribe(this.hide);
        UpdateMiniObserver.unsubscribe(this.updateMiniWithGroupIdFromStorage);
        UpdateMiniObserver.subscribe(this.updateMiniWithGroupIdFromStorage);
        UpdateMiniAfterRecordObserver.unsubscribe(this.updateMiniAfterRecord);
        UpdateMiniAfterRecordObserver.subscribe(this.updateMiniAfterRecord);
        document.removeEventListener('keydown', this.handleKeyPress, true);
        document.addEventListener('keydown', this.handleKeyPress, true);
        document.getElementById(this.mainContainer).removeEventListener('sn:focused', this.handleFocus);
        document.getElementById(this.mainContainer).addEventListener('sn:focused', this.handleFocus);
    }

    removeEventListener(){
        ShowMiniObserver.unsubscribe(this.show);
        HideMiniObserver.unsubscribe(this.hide);
        UpdateMiniObserver.unsubscribe(this.updateMiniWithGroupIdFromStorage);
        UpdateMiniAfterRecordObserver.unsubscribe(this.updateMiniAfterRecord);
        document.removeEventListener('keydown', this.handleKeyPress, true);
        document.getElementById(this.mainContainer).removeEventListener('sn:focused', this.handleFocus);
    }

    fillChannels(){
        if (this.channels.length === 0) {
            new ChannelsSingleton().getFilters().then(async filters => {
                if (Array.isArray(filters) && filters[0] && filters[0].id) {
                    const channels = await EPGUtil.getChannelsByFilterId(filters[0]);
                    if (Array.isArray(channels) && channels.length > 0) {
                        this.setChannels(channels);
                        this.updateMiniWithGroupIdFromStorage();
                    } else {
                        const channels = await new ChannelsSingleton().getChannels();
                        if (Array.isArray(channels) && channels.length > 0) {
                            this.setChannels(channels);
                            this.updateMiniWithGroupIdFromStorage();
                        }
                    }
                }
            });
            new ChannelsSingleton()
                .getMaxTimeshift()
                .then(maxTimeshift => {
                    this.maxTimeshiftAllowed = maxTimeshift;
                });
        }
    }

    checkRightFocus(){
        if(document.activeElement && (document.activeElement.id !== `mini-principal-event` || document.activeElement.id !== `mini-secondary-event`)){
            this.focusOnEvent('principal', true);
        }
    }


    getCurrentEventNow = async (currentEventDisplay = {}) =>{
        const isForcedEvent = this.forcedEvent && this.forcedEvent.group_id;
        const groupIdFromStorage = isForcedEvent ? this.forcedEvent.group_id : TvChannelUtil.getLastChannel();
        if(groupIdFromStorage){
          const currentEvent =  isForcedEvent ? forcedEvent : currentEventDisplay;
          if(currentEvent){
            this.eventFocused = {...currentEvent};
          }
        }
    }


    initialize(){
        const callbacks = {
            hide: ()=>{
                const cb = (currentEvent = {})=>{
                    this.getCurrentEventNow(currentEvent);
                }
                this.resetChannelIsPlaying(cb);
            },
            show: ()=>{
                this.checkRightFocus()
            }
        };
        this.miniDomManager.init(
            this.mainContainer,
            this.miniContainer,
            callbacks
        );
        this.fillChannels();
        initGetDataFromApa();
    }

    getNextIndex (index, direction) {
        let nextIndex = index + (direction === 'UP' ? -1 : 1);

        if (!this.channels[nextIndex]) {
            if (direction === 'UP'){
                nextIndex = this.channels.length - 1;
            } else {
                nextIndex = 0;
            }
        }

        if (isSkipNoSuscriptionChannelEneable()) {
            const { group_id = null } = this.channels[nextIndex] || {};

            if (ChannelsSingleton.canPlayChannel(group_id)) {
                return nextIndex;
            } else {
                return this.getNextIndex(nextIndex, direction);
            }
        } else {
            return nextIndex;
        }
    }

    clearEventProgress(type){
        this.miniDomManager.hideEventProgress(type);
    }

    checkEventTags(eventToDisplay) {
        this.clearEventProgress('principal');
        this.clearEventProgress('secondary');
        const typePrincipalEvent =this.setEventTag(eventToDisplay, 'principal');
        const typeSecondaryEvent = this.setEventTag(eventToDisplay.nextEvent, 'secondary');
        if(typePrincipalEvent === CURRENT_EVENTS || typeSecondaryEvent === CURRENT_EVENTS){
            this.whereAmI = CURRENT_EVENTS;
        }
        else if(typePrincipalEvent === PAST_EVENTS && typeSecondaryEvent === PAST_EVENTS){
            this.whereAmI = PAST_EVENTS;
        }
        else if(typePrincipalEvent === NEXT_EVENTS && typeSecondaryEvent === NEXT_EVENTS){
            this.whereAmI = NEXT_EVENTS;
        }
    }

    setEventProgress(event, type){
        if (event.date_begin && event.date_end)
            this.miniDomManager.renderEventProgress(event.date_begin, event.date_end, type);
    }

    updateMiniAfterRecord = () => {
        this.updateMiniEpg(this.forcedEvent);
    };

    setEventTag(event, type){
        if(!event)
            return '';
        if(isPastEvent({...event})){
            event.tag = PREVIOUS_EVENT_TAG;
            return PAST_EVENTS;
        }
        else if(isCurrentEvent({...event})){
            this.whereAmI = CURRENT_EVENTS;
            event.tag = NOW_EVENT_TAG;
            this.setEventProgress(event, type);
            return CURRENT_EVENTS;
        }
        else{
            if(event && event.date_begin){
                event.tag = FOR_LATE_EVENT_TAG;
                return NEXT_EVENTS;
            }
            else{
                if(type === 'principal'){
                    event.tag = NOW_EVENT_TAG;
                    return CURRENT_EVENTS;
                }
                else{
                    event.tag = FOR_LATE_EVENT_TAG;
                    return NEXT_EVENTS;
                }
            }
        }
    }

    async setMoreFutureEvents(){
        if(this.getDisplayedEvent() && this.getDisplayedEvent().nextEvent){
            const threshould = this.getThreshouldFromMetadata();
            const { date_end } = this.getDisplayedEvent().nextEvent || {} ;
            const { group_id } = this.getDisplayedChannel() || {};
            const events = await EpgEventsUtils.getEventsByTimeThreshold(group_id, date_end, date_end + (threshould * 3600), true );
            this.displayedChannelEvents = [...this.displayedChannelEvents, ...events];
            //implementacion vieja se mejora el performance
            // const nextEvent = await EPGUtil.getNextEventByEvent(this.getDisplayedEvent().nextEvent);
            // if(nextEvent){
            //     this.displayedChannelEvents = [...this.displayedChannelEvents, nextEvent];
            // }
        }
        return true;
    }

    hasMoreFutureEvents(){
        return this.displayedChannelEvents[this.displayedEventIndex + 1] && this.displayedChannelEvents[this.displayedEventIndex + 2];
    }

    hasMorePastEvents(){
        return this.displayedChannelEvents[this.displayedEventIndex - 1];
    }

    async setMorePastEvents(){
        if(this.getDisplayedEvent()){
            const threshould = this.getThreshouldFromMetadata();
            const { date_begin } = this.getDisplayedEvent() || {} ;
            const { group_id } = this.getDisplayedChannel() || {};
            const start = date_begin - (threshould * 3600), end = date_begin ;
            const events = await EpgEventsUtils.getEventsByTimeThreshold(group_id, start, end, true );
            this.displayedChannelEvents = [...events, ...this.displayedChannelEvents];
            this.displayedEventIndex = this.displayedEventIndex + events.length;
        }
        return true;
    }

    async moveHorizontal(direction, cb){
        try {
            this._isPromiseLoading = true;
            let eventIndexToDisplay = null;
            if(direction ==='RIGHT'){
                if(this.hasMoreFutureEvents()){
                    eventIndexToDisplay = this.displayedEventIndex + 1;
                }
                else{
                    await this.setMoreFutureEvents();
                    if(this.hasMoreFutureEvents()){
                        return this.moveHorizontal(direction, cb);
                    }
                }
            }
            else{
                if(this.hasMorePastEvents()){
                    eventIndexToDisplay = this.displayedEventIndex - 1;
                }
                else{
                    await this.setMorePastEvents();
                    if(this.hasMorePastEvents()){
                        return this.moveHorizontal(direction, cb);
                    }
                }
            }
            if(typeof eventIndexToDisplay === 'number'){
                this.renderEventsInDom(eventIndexToDisplay, true);
            }
            this._isPromiseLoading = false;
        } catch (e) {
            this._isPromiseLoading = false;
        }
        if (typeof cb === 'function') {
            cb();
        }
    }

    moveVertical(direction){
        if (!Array.isArray(this.channels) || this.channels.length === 0)
            return;
        const indexChannelToDisplay = this.getNextIndex(this.displayedChannelIndex, direction);
        this.setDisplayedChannelIndex(indexChannelToDisplay);
    }

    updateMiniEpg(forcedEvent = null, notReAssignForcedEvent = false, cb= () =>{}){
        if(!notReAssignForcedEvent){
            this.forcedEvent= forcedEvent;
        }
        const displayedChannel = this.getDisplayedChannel() || {};
        if (displayedChannel) {
            this.generateMiniEpg(displayedChannel, forcedEvent, cb);
        }
    }

    getThreshouldFromMetadata(){
        const thresholdFromMetadata = parseInt(Utils.getApaMetadataKey('mini_epg_threshold','{"threshold":12}',"threshold"));
        return thresholdFromMetadata;
    }

    calculateMiniEpgThreshold(extendEndTime = false){
        const thresholdFromMetadata = this.getThreshouldFromMetadata();
        const miniEpgThreshold = {
            startTimeThreshold: null,
            endTimeThreshold: null
        }
        if(this.maxTimeshiftAllowed){
            miniEpgThreshold.startTimeThreshold = thresholdFromMetadata;
            miniEpgThreshold.endTimeThreshold = thresholdFromMetadata;
        }
        else{
            miniEpgThreshold.startTimeThreshold = 0;
            miniEpgThreshold.endTimeThreshold = thresholdFromMetadata * 2;
        }
        if(extendEndTime){
            miniEpgThreshold.endTimeThreshold =  miniEpgThreshold.endTimeThreshold + thresholdFromMetadata
        }
        return miniEpgThreshold;
    }

    async generateMiniEpg(channelToDisplay, forcedEvent, cb =()=>{}){
        const { group_id = null } = channelToDisplay;
        if(group_id){
            this.renderChannelInDom(channelToDisplay);
            const {
                startTimeThreshold = null,
                endTimeThreshold = null
            } = this.calculateMiniEpgThreshold();
            const events = await EpgEventsUtils.getEventsByTimeThreshold(group_id, startTimeThreshold, endTimeThreshold);
            this.setDisplayedChannelEvents(events);
            const currentEventIndex = EpgEventsUtils.getCurrentEventIndexInEvent(events, forcedEvent);
            this.renderEventsInDom(currentEventIndex, true, cb);
            this.focusOnEvent('principal');
        }
    }

    onUpdateEpg(channel) {
        if (typeof this.props.onUpdateEpg === 'function') {
            this.props.onUpdateEpg(channel.group_id);
        }
    }

    changePlayingChannel(){
        if (typeof this.props.playFullMedia === 'function' && this.getDisplayedChannel() && this.getDisplayedChannel().group_id) {
            FallbackUtil.clearFallback();
            this.onUpdateEpg(this.getDisplayedChannel());
            const newChannel = {
                playerstate: AAFPLAYER_PLAY,
                source: {
                    videoid: this.getDisplayedChannel().group_id
                },
                size: {
                    top: 0,
                    left: 0,
                    width: 1280,
                    height: 720
                },
                ispreview: false,
                islive: true,
                ispip: false,
                event: null
            };
            this.props.playFullMedia(newChannel);
            this.forcedEvent = null;
        }
    }

    handleOkClick(e){
        const { hideMiniEpgWithVisibilityValidation = ()=>{} } = this.props;
        if(this.eventFocused){
            if(isCurrentEvent({...this.eventFocused})){
                this.changePlayingChannel();
            }
            else if(isPastEvent({...this.eventFocused})){
                    if(EpgEventUtils.canPlayPastEventAsCatchup({...this.eventFocused})){
                        this.props.playCatchupEvent({...this.eventFocused});
                    }
                    else{
                        hideMiniEpgWithVisibilityValidation();
                        this.props.showPassEventNotAvailableNotification();
                    }
            }
            else{

                const eventSelectect = {...this.eventFocused};
                //its future event
                const handleBluePress = (eventBlueHandler) => {
                    if(eventBlueHandler && eventBlueHandler.id && eventBlueHandler.group_id){
                        //para evitar que el click se propague
                        const event = {...eventBlueHandler};
                        FlagEventMini.setFromNot(true);
                        hideMiniEpgWithVisibilityValidation();
                        setTimeout(()=>{
                            ModalEpgUtils.blueHandler({
                                hideEpgOutsideCb: null,
                                handleGuideCb:null,
                                data: event,
                                streamType: this.props.streamType(),
                                streamContentType: this.props.getContentStreamType(),
                                changeLangCb: this.props.changeLang
                            });
                        }, 300);
                    }
                }

                hideMiniEpgWithVisibilityValidation();
                this.props.showFutureEventNotAvailableNotification(() =>{handleBluePress(eventSelectect)});
            }
        }
    }

    isModalPINOpen() {
        let flag = false;
        const modalNotToClose = [MODAL_PIN];
        if (modalNotToClose.indexOf(Utils.modalType()) !== -1) {
            flag = true;
        }
        return flag;
    }

    collectorKey(key, withUpdateMini = false) {
        switch (key) {
            case 'CH_DOWN':
              if(Utils.modalType() === MODAL_INACTIVITY){
                e.preventDefault();
                  e.stopPropagation();
                return;
              }
                if (this.isModalPINOpen()) {
                    return;
                }
                if (this.firstTimePressed) {
                    this.setDisplayedChannelIndex(this.playingChannelIndex);
                }
                this.moveVertical('UP');
                withUpdateMini && this.updateMiniEpg();
                this.firstTimePressed = false;
            break;
            case 'CH_UP':
              if(Utils.modalType() === MODAL_INACTIVITY){
                e.preventDefault();
                  e.stopPropagation();
                return;
              }
                if (this.isModalPINOpen()) {
                    return;
                }
                if (this.firstTimePressed) {
                    this.setDisplayedChannelIndex(this.playingChannelIndex);
                }
                this.moveVertical('DOWN');
                withUpdateMini && this.updateMiniEpg();
                this.firstTimePressed = false;
            break;
            default:
                break;
        }
        clearTimeout(this.pressTimer);
        this.pressTimer = this.delayChangePlayingChannel();
    }

    delayChangePlayingChannel(miliseconds = null) {
        if (miliseconds === null) {
            miliseconds = EpgPersistence.getDelayChangeChannel();
        }
        return setTimeout(() => {
            if (this._isPromiseLoading) {
                this.pressTimer = this.delayChangePlayingChannel(200);
                return;
            }
            this.firstTimePressed = true;
            this.changePlayingChannel();
        }, miliseconds);
    };

    eventIsCurrent(event) {
        if (event && event.date_begin) {
            const _now = Utils.nowAsTimestampSeconds();
            return event.date_begin <= _now && event.date_end >= _now;
        }
        return false;
    }

    hasTimeShif(event) {
        let result = true;
        const currentTime = Utils.nowAsTimestampSeconds();
        const maxTimeAllowed = currentTime - this.maxTimeshiftAllowed;

        if (event && event.date_begin) {
            if (this.maxTimeshiftAllowed === 0 && this.eventIsCurrent(event)) {
                result = false;
            }
            else {
                if (event.date_begin >= maxTimeAllowed) {
                    result = false;
                }
            }
        }
        return result;
    }

    handleKeyPress(e){
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        console.log('[PersistentMiniEpg] _handleKeyPress currentKey', currentKey);
        if(Utils.isModalCallCenterOpen()){
            return;
        }
        if (Utils.isModalEpgVersionOpen()) {
            return;
        }
        if(Utils.isModalEpgLive()){
            return;
        }
        if(!Utils.isNotificationHide() && Utils.modalType() !== MODAL_INACTIVITY){
            return;
        }
        if (Utils.isFullEpgPersistanceOpen() || LayersControl.isUXVisible() || this.notShow) {
            return;
        }
        if(this.props && (typeof this.props.getContentStreamType === 'function') && this.props.getContentStreamType() === AAF_CONTENT_IS_VOD){
            return;
        }

        if (
            this.props.enableButton('red') &&
            currentKey === 'RED'
        ) {
            if(!Utils.isNotificationHide()){
                return;
            }
            return this.props.onPressRedButton();
        }
        if (
            currentKey === 'LIST' ||
            currentKey === 'VOD' ||
            currentKey === 'PPE' ||
            currentKey === 'FAV'
        ) {
            this.hide();
        }
        if (
          /*this.props.enableButton('blue') && */
            currentKey === 'BLUE'
        ) {
            if(!Utils.isNotificationHide() || !Utils.isModalHide()){
                return;
            }
            if(FlagEventMini.getFromNot()){
                FlagEventMini.setFromNot(false);
                return;
            }

            if (this.eventFocused) {
                const event = {...this.eventFocused};
                const { hideMiniEpgWithVisibilityValidation = () => {} } = this.props
                hideMiniEpgWithVisibilityValidation();
                this.playerStreamingUtils.checkSusc(null, event.group_id).then(isSusc => {
                    if(isSusc){
                        ModalEpgUtils.blueHandler({
                            hideEpgOutsideCb: null,
                            handleGuideCb:null,
                            data: {...event},
                            streamType: this.props.streamType(),
                            streamContentType: this.props.getContentStreamType(),
                            changeLangCb: this.props.changeLang
                        });
                    }
                });
            }
        }
        if(currentKey === 'REC' && Utils.isMiniEpgPersistanceOpen()){
            e.stopPropagation();
            e.preventDefault();
            if (this.eventFocused) {
                const event = {...this.eventFocused};
                const { hideMiniEpgWithVisibilityValidation = () => {} } = this.props
                typeof hideMiniEpgWithVisibilityValidation === 'function' && hideMiniEpgWithVisibilityValidation();
                event && typeof this.props.record === 'function' && this.props.record({...event});
            }
            return;
        }
        if (currentKey === 'CH_UP' || currentKey === 'CH_DOWN') {
          if(Utils.modalType() === MODAL_INACTIVITY){
            e.preventDefault();
              e.stopPropagation();
            return;
          }
            console.log('[NPC] peristente mini chup chdown');
            FallbackUtil.clearFallback();
            const enableChannelChange = this.props.getContentStreamType() === AAF_CONTENT_IS_TV
                || this.props.getContentStreamType() === AAF_CONTENT_IS_STARTOVER
                || this.props.getContentStreamType() === AAF_CONTENT_IS_CATCHUP;
            // Sólo se permite el cambio en tv o en startover
            if(!enableChannelChange) {
                return;
            }
            const withUpdateMini = Utils.choiceBehaviorChannelChange();
            const chUpDownCb = () => {
                this.collectorKey(currentKey, withUpdateMini);
            };
            //this._keyWithDelay(chUpDownCb,300);
            if (!this._isPromiseLoading) {
                // Reset del autohide de PC mientras se mueva con chup, chdown
                this.props.resetAutoHideTimer();
                chUpDownCb();
            }
                return;
        }
        if (
            !this.miniDomManager.getVisibility('mini') ||
            !Utils.isModalHide()
        ) {
            console.log('[PersistentMiniEpg] not visible');
            return;
        }
        switch (currentKey) {
            case 'DOWN':
            case 'UP':
            const upDownCb = () => {
                this.moveVertical(currentKey);
                //this._setCurrentChannelByCurrentIndex();
                this.updateMiniEpg(null, true);
            };
            if (!this._isPromiseLoading) {
                upDownCb();
            }
            break;
            case 'OK':
                if (!Utils.isActionBarOpen()) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.handleOkClick();
                }
                break;
            case 'RIGHT':
                const rightCb = () => {
                    if (!this._isPromiseLoading){
                        this.moveHorizontal(currentKey, () => {
                            this.focusOnEvent('secondary');
                        });
                    }
                }
                if (document.activeElement === document.getElementById('mini-secondary-event')) {
                    if (!this._isPromiseLoading) {
                        rightCb();
                    }
                }
                break;
            case 'LEFT':
                if (this.displayedChannelEvents[this.displayedEventIndex-1]) {
                    if (this.hasTimeShif({...this.displayedChannelEvents[this.displayedEventIndex-1]})) {
                        return;
                    }
                }

                if (this.maxTimeshiftAllowed === 0 && this.displayedEventIndex === 0 && this.eventIsCurrent(this.displayedChannelEvents[this.displayedEventIndex])) {
                    return;
                }

                const leftCb = () => {
                    if (!this._isPromiseLoading)
                        this.moveHorizontal(currentKey, () => {
                            this.focusOnEvent('principal');
                        });
                };
                if (document.activeElement === document.getElementById('mini-principal-event')) {
                    leftCb();
                }
                break;
            default:
                break;
        }
    }

    handleFocus(e){
        console.log('[MiniGuide] _handleFocus');
        const { setNormalEventInfo = () => {} } = this.props;
        const id = e.srcElement.id;
        const displayedEvent = this.getDisplayedEvent();
        if (id === 'mini-principal-event') {
            if (displayedEvent) {
                this.eventFocused = { ...displayedEvent };
            }
            const currentEvent = this.displayedChannelEvents[this.currentEventIndex];
            if(currentEvent){
                setNormalEventInfo({...currentEvent})
            }
        }
        if (id === 'mini-secondary-event') {
            if (displayedEvent && displayedEvent.nextEvent) {
                this.eventFocused = { ...displayedEvent.nextEvent };
            }
        }
        if (typeof this.props.setCurrentEventInPlayerControls === 'function' && this.eventFocused) {
            const event = {
                eventId: this.eventFocused.id,
                number: this.eventFocused.channel_id,
                groupId: this.eventFocused.group_id,
                ext_series_id: this.eventFocused.ext_series_id || null,
                ext_season_id: this.eventFocused.ext_season_id || null,
                ext_episode_id: this.eventFocused.ext_episode_id || null
            };
            this.props.setCurrentEventInPlayerControls(event);
        }
    }

    focusOnEvent = (type, withDelay = false) => {
        const idToFocus = `mini-${type}-event`;
        this.handleFocus({ srcElement: { id: idToFocus }});
        if(document.activeElement && document.activeElement.id === idToFocus){
            return;
        }
        if (withDelay) {
        setTimeout(() => {
            if (Utils.isModalHide()) {
            window.SpatialNavigation.focus(`#${idToFocus}`);
            }
        }, 300);
        } else {
        if (Utils.isModalHide()) {
            window.SpatialNavigation.focus(`#${idToFocus}`);
        }
        }
    };

    componentWillReceiveProps(nextProps) {
        this.notShow = nextProps.notShow;
        if (nextProps.notShow) {
            this.hide();
        }
    }


    componentDidMount(){
        this.initialize();
        this.addEventListener();
        window.SpatialNavigation.makeFocusable();
    }

    shouldComponentUpdate() {
        return false;
    }

    componentWillUnmount() {
        this.removeEventListener();
        //this._stopBackgroundUpdate();
    }

    renderEventsInDom(eventIndexToDisplay, checkEventTags = false, cb = () => {}){
        this.setDisplayedEventIndex(eventIndexToDisplay);
        const eventToDisplay = this.getDisplayedEvent();
        if(eventToDisplay){
            const nextEventToDisplay = this.displayedChannelEvents[eventIndexToDisplay + 1];
            eventToDisplay.nextEvent = nextEventToDisplay;
            const channelToDisplay = this.getDisplayedChannel();
            if(checkEventTags){
                this.checkEventTags(eventToDisplay);
            }
            (typeof cb === 'function') && cb({...eventToDisplay});
            this.miniDomManager.renderEvents(eventToDisplay, channelToDisplay);
        }
    }

    renderChannelInDom(channel){
        this.miniDomManager.renderChannel(channel)
    }

    render(){
        const effectsEnabled = Utils.getApaMetadataKey('aaf_effects','{"enable":true}',"enable");
        const arrowUp = Asset.get('playingLive_miniEpg_toolbar_button_upChannel', '/images/mini-epg/chevron_up.png');
        const arrowDown = Asset.get('playingLive_miniEpg_toolbar_button_downChannel', '/images/mini-epg/chevron_down.png');
        const arrowLeft = Asset.get('playingLive_miniEpg_toolbar_button_leftProgram', '/images/mini-epg/chevron_left.png');
        const arrowRight = Asset.get('playingLive_miniEpg_toolbar_button_RightProgram', '/images/mini-epg/chevron_right.png');
        return (
            <div id={this.mainContainer}>
                <div
                    className={cls(
                        "mini-column mini-main-container ",
                        {
                        "fadeInMini": effectsEnabled
                        })}
                    id={this.miniContainer}
                    style={{ opacity: 0, visibility:'hidden' }}
                >
                    <PersistentMiniEpgArrow type="up" src={arrowUp}/>
                    <PersistentMiniEpgArrow type="down" src={arrowDown}/>
                    <PersistentMiniEpgArrow type="left" src={arrowLeft}/>
                    <PersistentMiniEpgArrow type="right" src={arrowRight}/>
                    <div className="mini-channel-events-container mini-row">
                        <PersistentMiniEpgChannel/>
                        <div id="mini-channel-block-icon">
                            <img  src={Asset.get('playingLive_channel_option_button_lockChannel', '/images/ic_block.png')} alt="lock"/>
                        </div>
                        <div className="mini-events-container mini-row">
                        <PersistentMiniEpgEvent type="principal" effectsEnabled={effectsEnabled}/>
                        <PersistentMiniEpgEvent type="secondary" effectsEnabled={effectsEnabled}/>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}

const mapStateToProps = null;

const mapDispatchToProps = {
    showFutureEventNotAvailableNotification,
    showPassEventNotAvailableNotification,
    playFullMedia,
    playCatchupEvent
}

export default connect(mapStateToProps, mapDispatchToProps)(MiniEpgOtt);



// WEBPACK FOOTER //
// ./src/components/PersistentMiniEpg/MiniEpgOtt/index.jsx